import { z } from 'zod';
import { isoTimestampSchema, uuidSchema } from './common';

/** Mirrors `NOTIFICATION_KINDS` in `@apis/db` (ADR-0046); the client renders each by kind. */
export const NOTIFICATION_KINDS = [
  'approval.pending',
  'approval.approved',
  'approval.rejected',
  'receipt.posted',
  'receipt.exceptions',
  'receipt.emergency_review',
  'requisition.pending_approval',
  'requisition.ready_to_pick',
  'requisition.rejected',
  'requisition.issued',
  'stock.low',
  'ap.due',
] as const;
export type NotificationKind = (typeof NOTIFICATION_KINDS)[number];

export const notificationSchema = z.object({
  id: uuidSchema,
  kind: z.enum(NOTIFICATION_KINDS),
  branch_id: uuidSchema.nullable(),
  params: z.record(z.string(), z.union([z.string(), z.number(), z.null()])),
  /** SPA path to open; switch to `branch_id` first. */
  link: z.string(),
  read_at: isoTimestampSchema.nullable(),
  created_at: isoTimestampSchema,
});
export type Notification = z.infer<typeof notificationSchema>;

export const notificationListSchema = z.object({
  items: z.array(notificationSchema),
  unread_count: z.number().int().nonnegative(),
});
export type NotificationList = z.infer<typeof notificationListSchema>;

/** Mark the given notifications read, or every unread one with `all`. */
export const markNotificationsReadRequestSchema = z.union([
  z.object({ ids: z.array(uuidSchema).min(1).max(50) }),
  z.object({ all: z.literal(true) }),
]);
export type MarkNotificationsReadRequest = z.infer<typeof markNotificationsReadRequestSchema>;

export const markNotificationsReadResponseSchema = z.object({
  unread_count: z.number().int().nonnegative(),
});
